import React from 'react';
import { Alert, AlertTitle, Typography, Button } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTrialStatus } from '../hooks/useTrialStatus';

const TrialWarningBanner = () => {
  const navigate = useNavigate();
  const { trialStatus, showWarning, daysRemaining, trialExpiresAt, isOnTrial, isPaid } = useTrialStatus();
  
  const isAuthenticated = !!Cookies.get('authToken');

  if (!isAuthenticated || !trialStatus || !showWarning || !isOnTrial || isPaid) {
    return null;
  }

  const formatExpiryDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch (e) {
      return dateString;
    }
  };

  const expiryDate = formatExpiryDate(trialExpiresAt);

  const handleContactSupport = () => {
    navigate('/contact');
  };

  return (
    <Alert 
      severity="warning" 
      icon={<Warning />}
      sx={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        borderRadius: 0,
        mb: 0,
        backgroundColor: '#fff3cd',
        borderBottom: '2px solid #ffc107',
        '& .MuiAlert-message': { width: '100%' }
      }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleContactSupport}
          sx={{
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          Contact Support
        </Button>
      }
    >
      <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
        Trial Period Ending Soon
      </AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Your 15-day free trial expires in{' '}
        <strong>{daysRemaining} {daysRemaining === 1 ? 'day' : 'days'}</strong>
        {expiryDate && ` (on ${expiryDate})`}. Contact support to convert to a paid plan.
      </Typography>
    </Alert>
  );
};

export default TrialWarningBanner;

